import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
 selector: 'iho-recursive-destinations',
 standalone: true,
 imports: [CommonModule],
 templateUrl: './recursive-destinations.component.html',
 styleUrls: ['./recursive-destinations.component.scss'],
})
export class RecursiveDestinationsComponent {
    @Input() destinations: any[] = [];
    @Input() level = 1;
}
